import { ServiceType } from 'types/generated/graphql';

import { ContactCredential } from './get-phone-numbers';

export type Emails = {
  email?: string;
  senderEmail?: string;
};

/**
 * Extracts e-mail addresses from customer PIN credentials based on service type.
 * Mirrors getPhoneNumbers so the e-mail shown next to the phone follows the same rules.
 *
 * @param credentials - Array of customer PIN credentials
 * @param serviceType - Type of service (Delivery, BagToBox, HandToHand)
 * @returns Object containing email (recipient) and senderEmail
 *
 * Service type rules:
 * - Delivery: No e-mails shown
 * - Bag to Box: Single e-mail from available credential
 * - Hand to Hand:
 *   - Recipient = pickupAction=true only (storeAction != true)
 *   - Sender = storeAction=true + pickupAction=true
 */
export const getEmails = (
  credentials: ReadonlyArray<ContactCredential> | undefined | null,
  serviceType: ServiceType | undefined | null
): Emails => {
  if (!credentials || !serviceType) {
    return {};
  }

  if (serviceType === ServiceType.Delivery) {
    return {};
  }

  if (serviceType === ServiceType.BagToBox) {
    return {
      email: credentials[0]?.email ?? undefined,
    };
  }

  if (serviceType === ServiceType.HandToHand) {
    const recipientCredentials = credentials.find(
      (cred) => cred.pickupAction === true && cred.storeAction !== true
    );
    const senderCredentials = credentials.find(
      (cred) => cred.storeAction === true && cred.pickupAction === true
    );

    return {
      email: recipientCredentials?.email ?? undefined,
      senderEmail: senderCredentials?.email ?? undefined,
    };
  }

  return {};
};
